var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1\\u306E\\u30B3\\u30D4\\u30FC",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1\\u306E\\u30B3\\u30D4\\u30FC",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #9CA3AF;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.07 3.1 7.23 13.39 2.02 8.03 .22 9.76 7.14 16.9 8.96 15.2 19.78 4.89 18.07 3.1 18.07 3.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGray);
export default __webpack_public_path__ + "static/media/Check_Gray.2f440beb1b728899f07b33008d117b9f.svg";
export { ForwardRef as ReactComponent };